export class Constant {
  public static readonly companyEmailAddress = 'contact@dondot.co.jp';
}
